export default "__VITE_ASSET__8a0fb4be__"